// extracted by mini-css-extract-plugin
export default {"desktopLogo":"GlobalHeaderLogo-module__desktopLogo___1oUAN","mobileLogo":"GlobalHeaderLogo-module__mobileLogo___2Tn37"};